import React from 'react';
import { isWeaslEvent } from "../../utils";

export default class MessageCaller extends React.Component {
  componentDidMount() {
    window.addEventListener('message', this.receiveMessage.bind(this), false);
  }

  receiveMessage(event) {
    if (isWeaslEvent(event)) {
      switch (event.data.type) {
        case 'SUBMIT_PAYMENT':
          this.props.handleSubmit(event);
          break;
        default:
          return;
      }
    }
  }
  render() {
    return <div/>
  }
}
